/**
 * 图标组件
 */

import React from 'react';

export interface IconStyle {
    color?: string;
    fontSize?: string;
}

interface Props {
    iconClassName: string;
    style?: IconStyle;
}

export function Icon ({iconClassName, style}: Props) {
    return (
        <i style={style} className={`xticon ${iconClassName}`}></i>
    );
}
